import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";

function Footer() {
  const backToTopOfPage = () => {
    window.scrollTo({ top: 0, lef: 0, behavior: "smooth" });
  };

  return (
    <div className="mt-auto bg-gray-200 w-full py-5">
      <div className="flex items-center justify-center gap-4">
        <p className="text-center font-sans text-black text-sm">
          &copy; {new Date().getFullYear()} - Lowtax Cash
        </p>
        <Tooltip title="Voltar ao topo da página">
          <button
            className="px-2 py-1 bg-gray-100 rounded-md hover:bg-gray-300 dark:text-black"
            onClick={() => backToTopOfPage()}
          >
            <FontAwesomeIcon icon={faArrowUp} size={"lg"} />
          </button>
        </Tooltip>
      </div>
    </div>
  );
}

export default Footer;
